import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
    setModalConfirmCallback,
    removeModalConfirmCallback,
} from "store/common/unsaved-data/unsaved-data-actions";
import { v4 as uuid } from "uuid";
import { AppDispatch } from "store/store";

const useRefreshPage = (refreshPageCallback: () => void): void => {
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        const callbackId = uuid();
        dispatch(
            setModalConfirmCallback({
                id: callbackId,
                isAutoDeleteResistant: true,
                isPageRedirect: false,
                callback: refreshPageCallback,
            })
        );

        return () => {
            dispatch(
                removeModalConfirmCallback(
                    (modalCallback) => modalCallback.id === callbackId
                )
            );
        };
    }, [dispatch, refreshPageCallback]);
};

export default useRefreshPage;
